module.exports = __webpack_public_path__ + "static/media/slide2.7f880788.jpg";